import i18n from '@plugins/i18n';

export default [
    {
        path: '/proposals',
        component: () => import('@/views/Investments.vue'),
        children: [
            {
                path: '/proposals',
                name: 'Proposals',
                component: () => import('@/views/Proposals.vue'),
                meta: {
                    overline: i18n.t('investments'),
                    title: i18n.t('_page.proposals.heading'),
                    heading: i18n.t('_page.proposals.heading'),
                    description: i18n.t('_page.proposals.description'),
                    organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER']
                }
            }
        ]
    }
];
